<template>


    <page-container :title="titlePage" noSteps>
      <template slot="description">
        <div>Комплексы упражнений</div>
      </template>

        <div class="panel">
          <div class="panel__filters filters">
            <el-select v-model="systemType"
                       @change="changeSystemType"
                       placeholder="Выберите"
                       class="filters__select filters__select--systems">
              <el-option v-for="item in humanSystemTypeList"
                         :key="item.id"
                         :label="item.title"
                         :value="item.id">
              </el-option>
            </el-select>
            <el-select v-model="specialistName"
                       placeholder="Выберите"
                       class="filters__select filters__select--specialists">
              <el-option label="Все специалисты" value="0">
              </el-option>
            </el-select>
          </div>
          <el-button icon="el-icon-plus"
                     type="text"
                     @click="create"
                     class="panel__button">Новый комплекс
          </el-button>
        </div>

        <complex-list v-loading="loading"
                      :complexList="complexList"
                      @update="loadList"></complex-list>

        <el-pagination
            v-if="showPagination"
            class="pagination"
            background
            layout="prev, pager, next"
            :page-size="pagination.per_page"
            :total="pagination.total"
            :current-page="pagination.current_page"
            @current-change="loadList"
        />

    </page-container>

</template>

<script>
import {mapGetters, mapActions} from "vuex"
import ComplexList from "@/components/complexExercises/ComplexList"
import PageContainer from "@/components/elements/PageContainer";


export default {
  name: "ComplexExercises.list",
  components: {ComplexList, PageContainer},
  data() {
    return {
      loading: false,
      complexList: null,
      pagination: null,
      systemType: null,
      specialistName: "",
      contentScroll: 0,
      humanSystemTypeList: []
    }
  },
  computed: {
    ...mapGetters({
      humanSystemTypes: "complexExercises/humanSystemTypes",
      loadingList: "complexExercises/loadingList"
    }),
    showPagination() {
      return this.pagination ? this.pagination.total > this.pagination.per_page : false;
    },
    pageTitle() {
      return this.$route.meta.title
    },
    stickyStyle() {
      return this.contentScroll >= 10 ? true : false
    },
    titlePage() {
      return this.$route.meta.title
    },
  },
  async activated() {
    await this.init()
  },
  async mounted() {
    // await this.init()
  },
  methods: {
    ...mapActions({
      getComplexListData: "complexExercises/getComplexListData",
      getHumanSystemTypes: "complexExercises/getHumanSystemTypes",
      endLoadingList: "complexExercises/endLoadingList"
    }),
    async createHumanSystemTypeList() {
      await this.getHumanSystemTypes()
      this.humanSystemTypeList = [
        {id: 0, title: "Все системы"},
        ...this.humanSystemTypes
      ]
    },
    loadList(page = 1) {
      let params = {
        params: {
          page,
          limit: 15,
          human_system_type_id: this.systemType ? this.systemType : null
        }
      }
      this.loading = true
      this.getComplexListData(params)
          .then(response => {
            this.complexList = response.items
            if (response.pagination) {
              this.pagination = response.pagination
            }
            this.endLoadingList()
          })
          .catch(() => {
            this.$notify.error({
              title: "Ошибка загрузки списка 😕"
            })
          })
          .finally(() => {
            this.loading = false
          })
    },
    changeSystemType() {
      this.loadList()
    },
    async init() {
      await this.loadList()
      if (!this.humanSystemTypeList.length) {
        this.createHumanSystemTypeList()
      }
    },
    editScroll(t) {
      this.contentScroll = t
    },
    create() {
      this.$router.push({name: "complexExercises.item"})
    }
  }
}
</script>

<style lang="scss" scoped>
@import "@/assets/scss/zebra-table.scss";


.filters {
  display: flex;
  justify-content: space-between;
  align-content: center;


  &__right {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  &__item {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  &__title {
    color: #8e8e93;
    font-size: 13px;
    line-height: 16px;
    padding: 0 5px;
  }

  &__phone {
    width: 215px;
  }

  &__department {
    width: 140px;
  }

  &__status {
    width: 110px;
  }

  &__select {
    width: 110px;
  }
}

.user-data {
  display: flex;
  justify-content: flex-start;
  align-items: center;

  &__photo {
    height: 40px;
    margin-right: 16px;
  }

  &__info {
    min-width: 130px;
  }

  .info-user {
    &__name {
      font-size: 13px;
      line-height: 16px;
      color: #111;

      &_mini {
        font-size: 13px;
        line-height: 16px;
        color: #8E8E93;
      }
    }

    &__phone {
      margin-top: 2px;

      font-size: 13px;
      line-height: 16px;
      color: #8c8c8c;
    }
  }
}


.el-table {
  margin-top: 40px !important;
}



.panel {
  margin-top: 20px;

  display: flex;
  justify-content: space-between;
  margin-bottom: 8px;
}

.filters {
  display: flex;
  justify-content: space-between;
  align-items: center;

  &__select {
    margin-right: 16px;

    &--systems {
      width: 118px;
    }

    &--specialists {
      width: 145px;
    }
  }
}

.panel__button {
  padding: 0 !important;

  font-weight: 500;
  font-size: 13px;
  line-height: 16px;
  letter-spacing: -0.005em;

  color: #078065;

  &:hover {
    text-decoration: underline;
  }
}

/deep/ .el-loading-mask {
  background-color: rgba(239, 239, 244, .87) !important;
}

</style>